<div class="container">
    <div class="header">
        <p class="title">{{ title() }}</p>
        <lib-trend-indicator [previousValue]="previousValue()" [currentValue]="currentValue()"></lib-trend-indicator>
    </div>
    <div class="statValue">
        @if (type() === 'currency') {
            <span>{{ currentValue() | currency: 'USD' : 'symbol' : '1.0-0' }}</span>
        }
        @if (type() === 'customPercentage') {
            <span>{{ currentValue() === 0 ? '@0.00%' : (currentValue() | customPercentage) }}</span>
        }
        @if (type() === 'none') {
            <span>{{ currentValue() }}</span>
        }
    </div>
</div>
